import { useEffect } from "react";

export function useMouseHover(ref, onMouseEnter, onMouseLeave) {
  useEffect(() => {
    const node = ref.current;
    if (node) {
      node.addEventListener("mouseenter", onMouseEnter);
      node.addEventListener("mouseleave", onMouseLeave);

      return () => {
        node.removeEventListener("mouseenter", onMouseEnter);
        node.removeEventListener("mouseleave", onMouseLeave);
      };
    }
  }, [ref, onMouseEnter, onMouseLeave]);
}
